import React from "react";
import { A, useQueryParams } from "hookrouter";
import { useAuth } from "./AuthHooks";
import styles from "./Login.module.css";
import Loading from "../Loading";

const Reset = () => {
  const [queryParams] = useQueryParams();
  const [form, setForm] = React.useState({});
  const [resetCode, setResetCode] = React.useState(queryParams.code);
  const { reset, loading } = useAuth();

  const handleSubmmit = (e) => {
    e.preventDefault();

    reset(JSON.stringify(form), resetCode);
  };

  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });
  };

  if (loading) {
    return <Loading />;
  }

  return (
    <div className={styles.formWrapper}>
      <div className={styles.title}>Reset Password</div>
      <div className={styles.subheading}>
        Enter key from your registered email to reset password
      </div>
      <form onSubmit={handleSubmmit}>
        <div className={styles.label}>Password</div>
        <input
          className={styles.field}
          type="password"
          name="password"
          onChange={handleChange}
          value={form.password}
          required
        />

        <div className={styles.label}>Password Again</div>
        <input
          className={styles.field}
          type="password"
          name="confirm_password"
          onChange={handleChange}
          value={form.confirm_password}
          required
        />

        {!queryParams.code && (
          <React.Fragment>
            <div className={styles.label}>Reset Code</div>
            <input
              className={styles.field}
              type="password"
              name="reset"
              onChange={(e) => setResetCode(e.target.value)}
              value={resetCode}
              required
            />
          </React.Fragment>
        )}

        <button className={styles.submit}>Reset Password</button>
      </form>
      <div className={styles.link}>
        <A href="/login">Login</A>

        <div>&middot;</div>

        <A href="/register">Sign up</A>
      </div>
    </div>
  );
};

export default Reset;
